<template>
    <el-drawer 
        title="手机号对调" 
        :visible.sync="changeVisible" 
        :before-close="closeDialog" 
        size="10ss00px" 
        class="punish-box"
    >
        <div class="drawer-content">			
			<el-alert type="warning" show-icon :closable="false" title="注意：原则上，只有两个账号均存在还未观看的演出时，才需要使用该功能满足用户的观看需求"></el-alert>
			<div class="changeMain">
				<el-card class="box-card">
					<div class="searchBox">
						<div class="page-filter-box">
						    <el-row :gutter="10">
						        <el-col :span="16">
						            <el-input placeholder="输入帐号ID"  v-model="params.userId"  size="small" type="number"></el-input>
						        </el-col>                    
						        <el-col :span="4" class="page-filter-btns">
						            <el-button type="primary" icon="el-icon-search"  size="small" @click="getData(1)">查询</el-button>                        
						        </el-col>
						    </el-row>
						</div>						
					</div>
					<div class="searchList">
						<ul class="container"  v-if="dataLeft">						   
						        <li v-if="dataLeft.id">
						            <div>账号ID:</div>
						            <div>{{dataLeft.id}} <span v-if="dataLeft.status ==0 " class="red">(账号已注销)</span></div>
						        </li>
						        <li v-if="dataLeft.userType">
						            <div>账号身份:</div>
						            <div> <p v-if="dataLeft.userType == 1 ">乐迷</p>
									<p v-else-if="dataLeft.userType == 2 ">艺人</p>
									<p v-else-if="dataLeft.userType == 3 ">场地</p>
									<p v-else-if="dataLeft.userType == 5 ">厂牌</p></div>
						        </li>
						        <li v-if="dataLeft.name">
						            <div>账号名称:</div>
						            <div>{{ dataLeft.name}}</div>
						        </li>
								<li v-if="dataLeft.activityOrderInfos && dataLeft.activityOrderInfos.length > 0">
								    <div>当前等待观看演出:</div>
								    <div> <p v-for="(item,index) in dataLeft.activityOrderInfos" :key="index" class="activityP">
										{{index + 1}} . {{item}}
									</p></div>
								</li>	
						       <li v-if="dataLeft.raiseOrderNum">
						           <div>当前已完成众筹订单:</div>
						           <div> {{dataLeft.raiseOrderNum}}</div>
						       </li>
							   <li v-if="dataLeft.goodsOrderNum">
							       <div>当前已完成周边订单:</div>
							       <div>{{dataLeft.goodsOrderNum}}</div>
							   </li>
							   <li v-if="dataLeft.tel" class="tel">
							       <div>手机号:</div>
							       <div>{{dataLeft.areaCode}} {{dataLeft.tel}}</div>
							   </li>
						</ul>
					</div>
				</el-card>
				<div class="separate-box">
				    <div>
				        <i class="el-icon-arrow-right icon"></i>
				    </div>                    
				</div> 
				<el-card class="box-card">
					<div class="searchBox">
						<div class="page-filter-box">
						    <el-row :gutter="10">
						        <el-col :span="16">
						            <el-input placeholder="输入帐号ID" v-model="params2.userId"  size="small" type="number"></el-input>
						        </el-col>                    
						        <el-col :span="4" class="page-filter-btns">
						            <el-button type="primary" icon="el-icon-search"  size="small" @click="getData(2)">查询</el-button>                        
						        </el-col>
						    </el-row>
						</div>
						<div class="drawer-footer">
						    <el-button @click="closeDialog">取 消</el-button>
						    <el-button type="primary" @click="goChange()" :loading="submitLoading">确认对调</el-button>
						</div>
					</div>
					<div class="searchList">
						<ul class="container"  v-if="dataRight">						   
						        <li v-if="dataRight.id">
						            <div>账号ID:</div>
						            <div>{{dataRight.id}} <span v-if="dataRight.status ==0 " class="red">(账号已注销)</span></div>
						        </li>
						        <li v-if="dataRight.userType">
						            <div>账号身份:</div>
						            <div> <p v-if="dataRight.userType == 1 ">乐迷</p>
									<p v-else-if="dataRight.userType == 2 ">艺人</p>
									<p v-else-if="dataRight.userType == 3 ">场地</p>
									<p v-else-if="dataRight.userType == 5 ">厂牌</p></div>
						        </li>
						        <li v-if="dataRight.name">
						            <div>账号名称:</div>
						            <div>{{ dataRight.name}} </div>
						        </li>
								<li v-if="dataRight.activityOrderInfos && dataRight.activityOrderInfos.length > 0">
								    <div>当前等待观看演出:</div>
								    <div> <p v-for="(item,index) in dataRight.activityOrderInfos" :key="index" class="activityP">
										{{index + 1}} . {{item}}
									</p></div>
								</li>	
						       <li v-if="dataRight.raiseOrderNum">
						           <div>当前已完成众筹订单:</div>
						           <div> {{dataRight.raiseOrderNum}}</div>
						       </li>
							   <li v-if="dataRight.goodsOrderNum">
							       <div>当前已完成周边订单:</div>
							       <div>{{dataRight.goodsOrderNum}}</div>
							   </li>
							   <li v-if="dataRight.tel" class="tel">
							       <div>手机号:</div>
							       <div>{{dataRight.areaCode}} {{dataRight.tel}}</div>
							   </li>
						</ul>
					</div>
				</el-card>				       
			</div>
			
		</div>
       
    </el-drawer>
</template>

<script>

export default {
    props: {
       changeVisible: {
            type: Boolean,
            default: false
        },
		
    },
    data(){       
      return {
		submitLoading: false,
		listLoading:false,
		params:{
		   userId:''
		},
		params2:{
		   userId:''
		},
		dataLeft: null,
		dataRight:null,
		     	
      }  
    },
    watch:{
       
    },
    methods: {
        
        closeDialog(){
            this.$emit('update:changeVisible', false);
            this.params.userId = ''    
			this.params2.userId = ''
			this.dataLeft = null
			this.dataRight = null
        },
		getData(num){			
			var params = ''
			 if( num == 1 ){
				 if( this.params.userId == '' ){
				 	 return this.$message.error("账号ID不能为空");
				 }else{
					 params = this.params 
				 }
				
			 }else{
				 if( this.params2.userId == '' ){
				 	 return this.$message.error("账号ID不能为空");
				 }else{
					  params = this.params2
				 }
				 
			 }
			this.listLoading = true;
			this.$request({
			    url: "/userInfo/rep_info",
			    method: "POST",
			    params: params
			})
			    .then((res) => {
			        const { state, msg, result } = res.data;
			        if (state == 1 && result) {
					   if( num == 1 ){
						   this.dataLeft = result
						   this.params.userId = this.dataLeft.id
					   }else if(  num == 2  ){
						   this.dataRight = result
						    this.params2.userId = this.dataRight.id
					   }
			        } else {
			            this.$message.error(msg || "请求失败");
			        }
			    })
			    .finally(() => {
			        this.listLoading = false;
			 });
		},
		goChange(){
			
			if( this.params.userId == '' || this.params2.userId == '' ){
				return this.$message.error("请补全账号ID");
			}
			
			this.$request({
			    url: "/userInfo/rep_tel",
			    method: "POST",
			    params: {
					childId:this.params.userId,
					mainId:this.params2.userId
				}
			})
			    .then((res) => {
			        const { state, msg } = res.data;
			        if (state == 1) {
					   this.$message.success("操作成功");
					   this.closeDialog();
					   this.$emit('onUpdate');
			        } else {
			            this.$message.error(msg || "请求失败");
			        }
			    })
			    .finally(() => {
			        
			 });
		}
    }
}
</script>
<style lang="scss" scoped>
.el-alert__icon.is-big{
	width: 16px !important;
	height: 16px !important;
}
.changeMain{
	margin-top: 20px;
	display: flex;
	justify-content: space-between;
	.box-card{
		width: 48%;
		
	}
}
.separate-box{
	width: 30px;
	display: flex;
	justify-content: center;
	align-items: center;
	div{
		width: 30px;
		height: 30px;
		display: flex;
		justify-content: center;
		align-items: center;
		border-radius: 50%;
		background: #ccc;
	}
	.icon{
		font-size: 20px;
		color: #fff;
	}
}
.container{
    &>li{
		height: 100%;
		overflow: hidden;
		clear: both;
        margin-bottom: 10px;
        .el-button{
            padding: 0;
        }
		div{
			float: left;			
		}
		.red{			
			color: #f00;
		}
        div:first-child{
			float: left;
            margin-right: 10px;
            width: 120px;
            min-width: 140px;
            text-align: right;
            color: $--color-info;
        }
       
        &:nth-last-child(1){
            margin: 0;
        }
		&.tel{
			font-size: 16rpx;
			color: #f00;
		}
        .activityP{
			display: block;
			width: 100%;
			margin: 5px 0;
			
		}
    }    
}
</style>